import React from 'react';

import styles from './ProportionateDistributionMethod.module.scss';

import RmdInputBox from '../../components/Shared/RmdInputBox/RmdInputBox';
import DisabledText from './DisabledText';
import MyToolTip from '../../components/Shared/MyToolTip/MyToolTip';
import { calculateAndFormatUnixDates } from '../../utils/date-utils';
import { currency } from '../../utils/utils';
import { updateSelectedReinvestment } from '../../redux/modules/shoppingCart/shoppingCart.module';
import iconInfoIimg from '../../assets/images/icon-questionmark.svg';

const FundDisplayText = ({
  fund,
  custom,
  handleValueChange,
  hasError,
  balanceFund,
  lock,
  reinvestBlock,
  value,
  balanceAsOfDate,
  retirement,
  newFund = false,
  fullName = '',
  dispatch,
  hasRmdEligibleFunds = false,
  hasAllUnavailableOnline = false,
}) => (
  <div
    className={`${styles['fund-block']} ${
      custom && styles['custom-fund-block']
    } ${reinvestBlock && styles['reinvest-fund-block']} ${
      (!hasAllUnavailableOnline || hasRmdEligibleFunds) &&
      styles['fund-block-locked']
    }`}
  >
    {!newFund && (
      <div className={styles['txt']}>
        <div className={`${styles['name']} blocked_data`}>
          {fund.fundName}{' '}
          <span className={styles['address']}>{fund.ticker}</span>
          {fund.sweep && (
            <span id={`sweep-${fund.ticker}`} className={`${styles.sweep}`}>
              <MyToolTip
                id={`sweep-${fund.agreementNumber}`}
                descriptionBody={
                  <div>
                    <p>
                      This Money Market fund is linked to your Brokerage Account{' '}
                      <span className="blocked_data orphan-line">
                        #{fund.linkedAgreementNumber}.
                      </span>
                    </p>
                    <p className={styles['sweep-tip-para']}>
                      Securities transactions and/or cash distributions from
                      positions held in that specific brokerage account will
                      settle in or out of this "sweep" account.
                    </p>
                  </div>
                }
                popOutPlacement="top"
                callerNode={
                  <span>
                    <span className={`${styles.sweepText}`}>Sweep</span>
                    <span className={styles['sweep-help-icon']}>
                      <img src={iconInfoIimg} alt="help" />
                    </span>
                  </span>
                }
                maxNoteWidth="500px"
              />
            </span>
          )}
        </div>
        <div
          className={`${styles['address']} blocked_data`}
          style={{ paddingLeft: 0 }}
        >
          <span>{fund.agreementNumber}</span> &nbsp;
          <span className="dot">&#9679;</span> &nbsp;
          <span>{fund.formattedEntityNames}</span>
        </div>
        <div className={styles['address']}>
          Balance:{' '}
          {retirement ? currency(fund.equityAsOf) : currency(fund.balanceAsOf)}
          <span className="effective-date">
            {' '}
            as of {calculateAndFormatUnixDates(balanceAsOfDate)}
          </span>
        </div>
        {lock && (
          <DisabledText
            effectiveDate={fund.address.effectiveDate}
            lockNote={fund.lockedText}
            agreementNumber={fund.agreementNumber}
            hasRmdEligibleFunds={hasRmdEligibleFunds}
            hasAllUnavailableOnline={hasAllUnavailableOnline}
          />
        )}
      </div>
    )}
    {newFund && (
      <div className={styles['txt']}>
        <div className={`${styles['name']} blocked_data`}>
          {fund.fundName}{' '}
          <span className={styles['address']}>{fund.ticker}</span>
          <span className={styles['new-fund-header']}>New</span>
          {fund.sweep && (
            <span id={`sweep-${fund.ticker}`} className={`${styles.sweep}`}>
              <MyToolTip
                id={`sweep-${fund.agreementNumber}`}
                descriptionBody={
                  <div>
                    <p>
                      This Money Market fund is linked to your Brokerage Account{' '}
                      <span className="blocked_data orphan-line">
                        #{fund.linkedAgreementNumber}.
                      </span>
                    </p>
                    <p className={styles['sweep-tip-para']}>
                      Securities transactions and/or cash distributions from
                      positions held in that specific brokerage account will
                      settle in or out of this "sweep" account.
                    </p>
                  </div>
                }
                popOutPlacement="top"
                callerNode={
                  <span>
                    <span className={`${styles.sweepText}`}>Sweep</span>
                    <span className={styles['sweep-help-icon']}>
                      <img src={iconInfoIimg} alt="help" />
                    </span>
                  </span>
                }
                maxNoteWidth="500px"
              />
            </span>
          )}
        </div>
        <div
          className={`${styles['address']} blocked_data`}
          style={{ paddingLeft: 0 }}
        >
          {fullName}
        </div>
        {lock && (
          <DisabledText
            effectiveDate={fund.address.effectiveDate}
            lockNote={fund.lockedText}
            agreementNumber={fund.agreementNumber}
            hasRmdEligibleFunds={hasRmdEligibleFunds}
            hasAllUnavailableOnline={hasAllUnavailableOnline}
          />
        )}
      </div>
    )}
    {custom && (
      <div className={styles['input']}>
        <RmdInputBox
          hasError={hasError}
          handleValueChange={handleValueChange}
          balanceFund={balanceFund}
          defaultValue={value}
          defaultPlaceHolder={value}
        />
        {balanceFund && (
          <div className={styles['insufficient-desc']}>
            Insufficient balance for this amount
          </div>
        )}
      </div>
    )}
    {newFund && (
      <button
        className={styles['button']}
        onClick={() => dispatch(updateSelectedReinvestment({}))}
      >
        Remove Fund
      </button>
    )}
  </div>
);

export default FundDisplayText;
